'use client'

import { usePathname } from 'next/navigation'
import Script from 'next/script'
import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
  }
}

// Helper function to safely call Meta Pixel functions
const safeMetaPixelCall = (callback: () => void) => {
  try {
    if (typeof window === 'undefined') return
    if (!window.fbq) {
      console.warn('Meta Pixel (fbq) is not initialized')
      return
    }
    callback()
  } catch (error) {
    console.error('Error calling Meta Pixel:', error)
  }
}

// Helper function to track Meta Pixel events
export const trackMetaPixelEvent = (eventName: string, data?: Record<string, any>) => {
  safeMetaPixelCall(() => {
    window.fbq('track', eventName, data)
  })
}

export const MetaPixel = () => {
  const pathname = usePathname()

  useEffect(() => {
    safeMetaPixelCall(() => {
      window.fbq('init', '1748888219308277')
      window.fbq('track', 'PageView')
    })
  }, [])

  // Track page views when route changes
  useEffect(() => {
    safeMetaPixelCall(() => {
      window.fbq('track', 'PageView')
    })
  }, [pathname])
  return (
    <>
      <Script id="meta-pixel-script" strategy="afterInteractive">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1748888219308277');
          fbq('track', 'PageView');
        `}
      </Script>
      <noscript>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=1748888219308277&ev=PageView&noscript=1"
          alt=""
        />
      </noscript>
    </>
  )
}

export default MetaPixel
